import DocumentCostCentersModal from './costCenters/DocumentCostCentersModal';
import { getDocumentGrossAmount } from '../../utils/documentGrossAmount';

/**
 * Wrapper de compatibilidad para tabla / detalle documento.
 * Montos siempre en bruto (sin conversión a neto).
 */
const CostCenterModal = ({
  isMassive,
  companyId,
  selectedDocumentsIds,
  selectedAmount,
  documentCostCenters,
  isVisible,
  setIsVisible,
  reexecuteCostCentersByDocument,
  document: documentProp,
}) => {
  const grossFromDoc = documentProp ? getDocumentGrossAmount(documentProp) : 0;
  const grossAmount = grossFromDoc > 0 ? grossFromDoc : (selectedAmount || 0);

  return (
    <DocumentCostCentersModal
      open={isVisible}
      onClose={() => setIsVisible(false)}
      companyId={companyId}
      documentsIds={selectedDocumentsIds || []}
      grossAmount={grossAmount}
      initialCostCenters={documentCostCenters || []}
      isMassive={isMassive}
      onSuccess={reexecuteCostCentersByDocument}
    />
  );
};

export default CostCenterModal;
